import { AccountContract } from '../store/accounts/types';

export const parseAccounts = (
  accounts: AccountContract[],
): AccountContract[] => {
  return accounts.map((account) => parseAccount(account));
};

export const parseAccount = (account: AccountContract): AccountContract => {
  return {
    ...account,
    lastVisitDate: new Date(account.lastVisitDate),
    idealNextVisitDate: new Date(account.idealNextVisitDate),
    nextVisitDate: account.nextVisitDate
      ? new Date(account.nextVisitDate)
      : undefined,
  };
};
